module.exports = __webpack_public_path__ + "static/media/abstract-dynamic-logo-vector.63276a35.jpg";